<script>
    import routes from './routes'
    import Router from 'svelte-spa-router'
</script>

<main>
    <Router {routes}/>
</main>

<style global>
    main {
        height: 100vh;
    }

    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    @layer components {
        .changelogDiv {
            @apply flex flex-col items-center m-1 2xl:text-base
        }
        .version {
            @apply text-lg font-semibold p-1 2xl:text-xl
        }
    }

    @layer utilities {
        .offline {
            background-color: rgb(212, 212, 212);
        }
        .idle {
            background-color: rgb(128, 255, 0);
        }
        .error {
            background-color: rgb(255, 0, 0);
        }
        .running {
            background-color: rgb(255, 255, 0);
        }
        .overdue {
            background-color: rgb(266, 169, 0);
        }
    }
</style>
